import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { User } from '../../../../../../model/user/User';
import { CustomAutocomplete } from '../../../../../../shared/components/Autocomplete';

interface IProps {
    selectedPlatformId: { id: string };
    influencers: User[] | undefined;
    setSelectedPlatformId: React.Dispatch<React.SetStateAction<{ id: string }>>;
}

export const DetailedPerPlatformFilter = ({ selectedPlatformId, setSelectedPlatformId, influencers }: IProps) => {
    const { t } = useTranslation();
    const [selectedInfluencer, setSelectedInfluencer] = useState<User>();

    const changeHandler = (paramKey: string, paramValue: string | string[] | number) => {
        // @ts-ignore
        setSelectedPlatformId({ [paramKey]: paramValue });
    };

    useEffect(() => {
        if (!!+selectedPlatformId?.id && influencers) {
            setSelectedInfluencer(influencers?.find(influencer => +influencer?.id! === +selectedPlatformId?.id));
        }
    }, [selectedPlatformId?.id, JSON.stringify(influencers)]);

    return (
        <div className="d-flex align-items-md-center justify-content-between flex-column flex-md-row mt-5 mb-2">
            <h4 className="m-md-0">{t('brand.campaign.measure.detailedPerPlatform')}</h4>
            <div className="measure-dropdown">
                <CustomAutocomplete
                    dataArray={influencers as User[]}
                    isWithImage={true}
                    defaultArray={
                        influencers?.find(influencer => influencer.id === +selectedPlatformId?.id) as unknown as []
                    }
                    queryFilterKey="id"
                    changeEventKey="displayName"
                    inputLabel="displayName"
                    photoLabel="profilePhoto.path"
                    selectedStateImage={selectedInfluencer?.profilePhoto?.path as string}
                    handleChangeParams={changeHandler}
                    inputLabelTranslation={t('general.allInfluencers')}
                    me={true}
                />
            </div>
        </div>
    );
};
